/* ==========================================
   KANSTINGERS EDELMETALLPORTAL
========================================== */

const API_URL = "https://goldpreis.old-queen-5030.workers.dev";

let spot = {};
let positionen = [];

/* ==========================================
   HILFSFUNKTIONEN
========================================== */

function euro(value){

    return new Intl.NumberFormat("de-DE",{
        style:"currency",
        currency:"EUR"
    }).format(value);

}

function gramm(value){

    return euro(value)+" / g";

}

function $(selector){

    return document.querySelector(selector);

}

function $$(selector){

    return document.querySelectorAll(selector);

}
/* ==========================================
   LIVE-DATEN ABRUFEN
========================================== */

async function ladeLivePreise(){

    try{

        const response = await fetch(API_URL,{
            method:"GET",
            cache:"no-store",
            headers:{
                "Accept":"application/json"
            }
        });

        if(!response.ok){

            throw new Error("Fehler beim Abrufen der Live-Preise");

        }

        const daten = await response.json();

        /*
        Unterstützte Worker-Strukturen:

        {
            gold: 112,
            silver: 1.50,
            platinum: 45,
            palladium: 38
        }

        oder:

        {
            prices:{
                gold:112,
                silver:1.50,
                platinum:45,
                palladium:38
            }
        }
        */

       const quelle = daten.prices || daten;

spot = {

    gold: Number(
        quelle.gold?.boerse ??
        quelle.goldPerGram ??
        quelle.XAU ??
        quelle.xau ??
        quelle.gold ??
        0
    ),

    silver: Number(
        quelle.silber?.boerse ??
        quelle.silver?.boerse ??
        quelle.silverPerGram ??
        quelle.XAG ??
        quelle.xag ??
        quelle.silver ??
        0
    ),

    platinum: Number(
        quelle.platin?.boerse ??
        quelle.platinum?.boerse ??
        quelle.platinumPerGram ??
        quelle.XPT ??
        quelle.xpt ??
        quelle.platinum ??
        0
    ),

    palladium: Number(
        quelle.palladium?.boerse ??
        quelle.palladiumPerGram ??
        quelle.XPD ??
        quelle.xpd ??
        quelle.palladium ??
        0
    )

};

        if(
            spot.gold <= 0 ||
            spot.silver <= 0 ||
            spot.platinum <= 0 ||
            spot.palladium <= 0
        ){

            throw new Error("Unvollständige Kursdaten erhalten");

        }

        berechneAnkaufspreise();
        aktualisierePreisAnzeige();

        console.log(
            "Kanstingers Edelmetallpreise erfolgreich geladen:",
            spot
        );

    }catch(error){

        console.error(
            "Kanstingers Edelmetallportal:",
            error
        );

        zeigePreisFehler();

    }

}


/* ==========================================
   ANKAUFSPREISE BERECHNEN
========================================== */

function berechneAnkaufspreise(){

    spot.ankauf = {

        gold:{

            bankAb100:
                spot.gold * 0.97,

            bankBis100:
                spot.gold * 0.96,

            schmelzAb500:
                spot.gold * 0.95,

            schmelzBis500:
                spot.gold * 0.93,

            schmelzBis50:
                spot.gold * 0.90

        },

        silver:{

            bankAb3000:
                spot.silver * 0.90,

            bankBis3000:
                spot.silver * 0.85,

            schmelzAb50000:
                spot.silver * 0.80,

            schmelzBis50000:
                spot.silver * 0.70,

            schmelzBis5000:
                spot.silver * 0.60

        },

        platinum:
            spot.platinum * 0.75,

        palladium:
            spot.palladium * 0.75

    };


    /* Beliebte Legierungen */

    spot.legierungen = {

        gold333:
            spot.gold *
            0.333 *
            0.90,

        gold375:
            spot.gold *
            0.375 *
            0.90,

        gold585:
            spot.gold *
            0.585 *
            0.90,

        gold750:
            spot.gold *
            0.750 *
            0.90,

        gold833:
            spot.gold *
            0.833 *
            0.90,

        gold900:
            spot.gold *
            0.900 *
            0.90,

        gold916:
            spot.gold *
            0.916 *
            0.90,

        gold999:
            spot.gold *
            0.999 *
            0.90,

        silver800:
            spot.silver *
            0.800 *
            0.60,

        silver835:
            spot.silver *
            0.835 *
            0.60,

        silver900:
            spot.silver *
            0.900 *
            0.60,

        silver925:
            spot.silver *
            0.925 *
            0.60,

        silver999:
            spot.silver *
            0.999 *
            0.60

    };

}


/* ==========================================
   PREISE IM HTML AKTUALISIEREN
========================================== */

function setzePreis(key,value,einheit="/ g"){

    $$('[data-price-key="'+key+'"]').forEach(function(element){

        element.textContent =
            euro(value) +
            (einheit ? " "+einheit : "");

        element.classList.remove("is-loading");

    });

}


function aktualisierePreisAnzeige(){

    /* Live-Börsenkurse */

    setzePreis(
        "goldSpot",
        spot.gold
    );

    setzePreis(
        "silverSpot",
        spot.silver
    );

    setzePreis(
        "platinumSpot",
        spot.platinum
    );

    setzePreis(
        "palladiumSpot",
        spot.palladium
    );


    /* Gold-Ankaufspreise */

    setzePreis(
        "goldBankOver100",
        spot.ankauf.gold.bankAb100
    );

    setzePreis(
        "goldBankUpTo100",
        spot.ankauf.gold.bankBis100
    );

    setzePreis(
        "goldMeltOver500",
        spot.ankauf.gold.schmelzAb500
    );

    setzePreis(
        "goldMeltUpTo500",
        spot.ankauf.gold.schmelzBis500
    );

    setzePreis(
        "goldMeltUpTo50",
        spot.ankauf.gold.schmelzBis50
    );


    /* Silber-Ankaufspreise */

    setzePreis(
        "silverBankOver3000",
        spot.ankauf.silver.bankAb3000
    );

    setzePreis(
        "silverBankUpTo3000",
        spot.ankauf.silver.bankBis3000
    );

    setzePreis(
        "silverMeltOver50000",
        spot.ankauf.silver.schmelzAb50000
    );

    setzePreis(
        "silverMeltUpTo50000",
        spot.ankauf.silver.schmelzBis50000
    );

    setzePreis(
        "silverMeltUpTo5000",
        spot.ankauf.silver.schmelzBis5000
    );


    /* Platin und Palladium */

    setzePreis(
        "platinumPurchase",
        spot.ankauf.platinum
    );

    setzePreis(
        "palladiumPurchase",
        spot.ankauf.palladium
    );


    /* Beliebte Ankaufspreise */

    setzePreis(
        "gold750",
        spot.legierungen.gold750
    );

    setzePreis(
        "gold585",
        spot.legierungen.gold585
    );

    setzePreis(
        "silver925",
        spot.legierungen.silver925
    );


    /* Weitere Materialien */

    setzePreis(
        "silverwareA",
        30,
        "/ kg"
    );

    setzePreis(
        "knivesA",
        10,
        "/ kg"
    );

    setzePreis(
        "silverwareB",
        20,
        "/ kg"
    );

    setzePreis(
        "knivesB",
        5,
        "/ kg"
    );

    setzePreis(
        "lowSilvered",
        5,
        "/ kg"
    );

    setzePreis(
        "tin",
        15,
        "/ kg"
    );


    /* Zeitpunkt aktualisieren */

    const zeitElement =
        $("[data-price-timestamp]");

    if(zeitElement){

        zeitElement.textContent =
            new Intl.DateTimeFormat(
                "de-DE",
                {
                    dateStyle:"short",
                    timeStyle:"short"
                }
            ).format(new Date());

    }

}


/* ==========================================
   FEHLERMELDUNG BEI PREISABRUF
========================================== */

function zeigePreisFehler(){

    $$("[data-price-key]").forEach(function(element){

        element.classList.remove("is-loading");

        if(
            element.textContent.trim() === "" ||
            element.textContent.trim() === "--"
        ){

            element.textContent =
                "Derzeit nicht verfügbar";

        }

    });

    const status =
        $("[data-portal-status]");

    if(status){

        status.textContent =
            "Die Live-Preise konnten momentan nicht geladen werden.";

        status.classList.remove(
            "hidden",
            "portal-success"
        );

        status.classList.add(
            "portal-error"
        );

    }

}
/* ==========================================
   MEHRFACH-ANKAUFSRECHNER
========================================== */

let ausgewaehltesMetall = "gold";
let ausgewaehlteLegierung = 585;


/* ==========================================
   LEGIERUNGEN PRO METALL
========================================== */

const legierungen = {

    gold:[
        333,
        375,
        585,
        750,
        833,
        900,
        916,
        999
    ],

    silver:[
        800,
        835,
        900,
        925,
        999
    ],

    platinum:[
        585,
        750,
        850,
        900,
        950,
        999
    ],

    palladium:[
        500,
        585,
        950,
        999
    ]

};


/* ==========================================
   METALL AUSWÄHLEN
========================================== */

function waehleMetall(metall){

    if(!legierungen[metall]){
        return;
    }

    ausgewaehltesMetall = metall;

    ausgewaehlteLegierung =
        legierungen[metall][0];

    $$("[data-metal]").forEach(function(button){

        const istAktiv =
            button.dataset.metal === metall;

        button.classList.toggle(
            "is-active",
            istAktiv
        );

        button.setAttribute(
            "aria-pressed",
            istAktiv ? "true" : "false"
        );

    });

    rendereLegierungen();
    aktualisiereVorschau();

}


/* ==========================================
   LEGIERUNGSBUTTONS ERZEUGEN
========================================== */

function rendereLegierungen(){

    const container =
        $("[data-alloy-buttons]");

    if(!container){
        return;
    }

    container.innerHTML = "";

    legierungen[
        ausgewaehltesMetall
    ].forEach(function(legierung){

        const button =
            document.createElement("button");

        button.type = "button";

        button.className =
            "alloy-button";

        button.dataset.alloy =
            String(legierung);

        button.textContent =
            String(legierung);

        const istAktiv =
            legierung ===
            ausgewaehlteLegierung;

        if(istAktiv){

            button.classList.add(
                "is-active"
            );

        }

        if(
            ausgewaehltesMetall === "gold" &&
            (
                legierung === 585 ||
                legierung === 750
            )
        ){

            button.classList.add(
                "is-popular"
            );

        }

        if(
            ausgewaehltesMetall === "silver" &&
            legierung === 925
        ){

            button.classList.add(
                "is-popular"
            );

        }

        button.setAttribute(
            "aria-pressed",
            istAktiv ? "true" : "false"
        );

        container.appendChild(button);

    });

}


/* ==========================================
   LEGIERUNG AUSWÄHLEN
========================================== */

function waehleLegierung(legierung){

    const wert =
        Number(legierung);

    if(!Number.isFinite(wert)){
        return;
    }

    ausgewaehlteLegierung =
        wert;

    $$("[data-alloy]").forEach(function(button){

        const istAktiv =
            Number(button.dataset.alloy) ===
            wert;

        button.classList.toggle(
            "is-active",
            istAktiv
        );

        button.setAttribute(
            "aria-pressed",
            istAktiv ? "true" : "false"
        );

    });

    aktualisiereVorschau();

}


/* ==========================================
   GEWICHT AUSLESEN
========================================== */

function holeGewicht(){

    const input =
        $("[data-weight-input]");

    if(!input){
        return 0;
    }

    const wert =
        String(input.value)
        .trim()
        .replace(/\s/g,"")
        .replace(/\./g,"")
        .replace(",",".");

    const gewicht =
        Number(wert);

    if(
        !Number.isFinite(gewicht) ||
        gewicht <= 0
    ){

        return 0;

    }

    return gewicht;

}


/* ==========================================
   ABSCHLAG FÜR RECHNER BESTIMMEN
========================================== */

function holeRechnerAbschlag(
    metall,
    gewicht
){

    if(metall === "gold"){

        if(gewicht <= 50){
            return 0.10;
        }

        if(gewicht <= 500){
            return 0.07;
        }

        return 0.05;

    }

    if(metall === "silver"){

        if(gewicht <= 5000){
            return 0.40;
        }

        if(gewicht <= 50000){
            return 0.30;
        }

        return 0.20;

    }

    if(metall === "platinum"){
        return 0.25;
    }

    if(metall === "palladium"){
        return 0.25;
    }

    return 0;

}


/* ==========================================
   POSITIONSWERT BERECHNEN
========================================== */

function berechnePositionswert(
    metall,
    legierung,
    gewicht
){

    if(
        !spot ||
        !spot[metall]
    ){

        return 0;

    }

    const feingehalt =
        Number(legierung) / 1000;

    const abschlag =
        holeRechnerAbschlag(
            metall,
            gewicht
        );

    return (
        spot[metall] *
        feingehalt *
        gewicht *
        (1 - abschlag)
    );

}


/* ==========================================
   VORSCHAU AKTUALISIEREN
========================================== */

function aktualisiereVorschau(){

    const vorschau =
        $("[data-preview-value]");

    if(!vorschau){
        return;
    }

    const gewicht =
        holeGewicht();

    const wert =
        berechnePositionswert(
            ausgewaehltesMetall,
            ausgewaehlteLegierung,
            gewicht
        );

    vorschau.textContent =
        euro(wert);

}


/* ==========================================
   METALLNAME
========================================== */

function metallName(metall){

    const namen = {

        gold:"Gold",

        silver:"Silber",

        platinum:"Platin",

        palladium:"Palladium"

    };

    return namen[metall] || metall;

}


/* ==========================================
   POSITION HINZUFÜGEN
========================================== */

function fuegePositionHinzu(){

    const gewichtInput =
        $("[data-weight-input]");

    const gewicht =
        holeGewicht();

    if(gewicht <= 0){

        const status =
            $("[data-portal-status]");

        if(status){

            status.textContent =
                "Bitte geben Sie ein gültiges Gewicht ein.";

            status.classList.remove(
                "hidden",
                "portal-success"
            );

            status.classList.add(
                "portal-error"
            );

        }

        if(gewichtInput){
            gewichtInput.focus();
        }

        return;

    }

    if(
        !spot ||
        !spot[
            ausgewaehltesMetall
        ]
    ){

        const status =
            $("[data-portal-status]");

        if(status){

            status.textContent =
                "Die Live-Preise sind noch nicht verfügbar.";

            status.classList.remove(
                "hidden",
                "portal-success"
            );

            status.classList.add(
                "portal-error"
            );

        }

        return;

    }

    const wert =
        berechnePositionswert(
            ausgewaehltesMetall,
            ausgewaehlteLegierung,
            gewicht
        );

    positionen.push({

        id:
            Date.now() +
            "-" +
            Math.random()
            .toString(16)
            .slice(2),

        metall:
            ausgewaehltesMetall,

        legierung:
            ausgewaehlteLegierung,

        gewicht:
            gewicht,

        wert:
            wert

    });

    if(gewichtInput){
        gewichtInput.value = "";
    }

    const status =
        $("[data-portal-status]");

    if(status){

        status.textContent = "";

        status.classList.add(
            "hidden"
        );

        status.classList.remove(
            "portal-error",
            "portal-success"
        );

    }

    aktualisiereVorschau();
    renderePositionen();

}


/* ==========================================
   POSITION LÖSCHEN
========================================== */

function loeschePosition(id){

    positionen =
        positionen.filter(
            function(position){

                return position.id !== id;

            }
        );

    renderePositionen();

}


/* ==========================================
   ALLE POSITIONEN LÖSCHEN
========================================== */

function loescheAllePositionen(){

    positionen = [];

    renderePositionen();

}


/* ==========================================
   POSITIONEN ANZEIGEN
========================================== */

function renderePositionen(){

    const liste =
        $("[data-positions-list]");

    const gesamtElement =
        $("[data-total-value]");

    const leerElement =
        $("[data-calculator-empty]");

    if(
        !liste ||
        !gesamtElement
    ){

        return;

    }

    liste.innerHTML = "";

    positionen.forEach(
        function(position){

            position.wert =
                berechnePositionswert(
                    position.metall,
                    position.legierung,
                    position.gewicht
                );

            const karte =
                document.createElement(
                    "article"
                );

            karte.className =
                "position-card";

            karte.dataset.positionId =
                position.id;


            const punkt =
                document.createElement(
                    "span"
                );

            punkt.className =
                "position-metal-dot " +
                position.metall;

            punkt.setAttribute(
                "aria-hidden",
                "true"
            );


            const inhalt =
                document.createElement(
                    "div"
                );


            const titel =
                document.createElement(
                    "div"
                );

            titel.className =
                "position-title";

            titel.textContent =
                metallName(
                    position.metall
                ) +
                " " +
                position.legierung;


            const meta =
                document.createElement(
                    "div"
                );

            meta.className =
                "position-meta";

            meta.textContent =
                new Intl.NumberFormat(
                    "de-DE",
                    {
                        minimumFractionDigits:2,
                        maximumFractionDigits:2
                    }
                ).format(
                    position.gewicht
                ) +
                " g";


            inhalt.appendChild(titel);
            inhalt.appendChild(meta);


            const preis =
                document.createElement(
                    "div"
                );

            preis.className =
                "position-price";

            preis.textContent =
                euro(
                    position.wert
                );


            const loeschenButton =
                document.createElement(
                    "button"
                );

            loeschenButton.type =
                "button";

            loeschenButton.className =
                "remove-position-button";

            loeschenButton.dataset.removePosition =
                position.id;

            loeschenButton.setAttribute(
                "aria-label",
                metallName(
                    position.metall
                ) +
                " " +
                position.legierung +
                " entfernen"
            );

            loeschenButton.textContent =
                "×";


            karte.appendChild(punkt);
            karte.appendChild(inhalt);
            karte.appendChild(preis);
            karte.appendChild(
                loeschenButton
            );

            liste.appendChild(karte);

        }
    );


    if(leerElement){

        leerElement.classList.toggle(
            "hidden",
            positionen.length > 0
        );

    }


    const gesamt =
        positionen.reduce(
            function(summe,position){

                return (
                    summe +
                    position.wert
                );

            },
            0
        );

    gesamtElement.textContent =
        euro(gesamt);


    const anzahlElement =
        $("[data-position-count]");

    if(anzahlElement){

        anzahlElement.textContent =
            String(
                positionen.length
            );

    }

}
/* ==========================================
   PORTAL INITIALISIEREN
========================================== */

function initialisierePortal(){

    const portal =
        document.querySelector(
            "#kanstingers-edelmetallportal"
        );

    if(!portal){
        return;
    }


    /* Metall auswählen */

    portal.addEventListener(
        "click",
        function(event){

            const metallButton =
                event.target.closest(
                    "[data-metal]"
                );

            if(metallButton){

                waehleMetall(
                    metallButton.dataset.metal
                );

                return;

            }


            /* Legierung auswählen */

            const legierungsButton =
                event.target.closest(
                    "[data-alloy]"
                );

            if(legierungsButton){

                waehleLegierung(
                    legierungsButton.dataset.alloy
                );

                return;

            }


            /* Position hinzufügen */

            const hinzufuegenButton =
                event.target.closest(
                    "[data-add-position]"
                );

            if(hinzufuegenButton){

                fuegePositionHinzu();

                return;

            }


            /* Einzelne Position löschen */

            const loeschenButton =
                event.target.closest(
                    "[data-remove-position]"
                );

            if(loeschenButton){

                loeschePosition(
                    loeschenButton.dataset.removePosition
                );

                return;

            }


            /* Alle Positionen löschen */

            const alleLoeschenButton =
                event.target.closest(
                    "[data-clear-all]"
                );

            if(alleLoeschenButton){

                loescheAllePositionen();

            }

        }
    );


    /* Gewichtseingabe überwachen */

    const gewichtInput =
        portal.querySelector(
            "[data-weight-input]"
        );

    if(gewichtInput){

        gewichtInput.addEventListener(
            "input",
            aktualisiereVorschau
        );

        gewichtInput.addEventListener(
            "keydown",
            function(event){

                if(event.key === "Enter"){

                    event.preventDefault();
                    fuegePositionHinzu();

                }

            }
        );

    }


    /* Grundeinstellung laden */

    waehleMetall("gold");
    renderePositionen();
    aktualisiereVorschau();
    ladeLivePreise();

}


/* Erst starten, wenn das HTML verfügbar ist */

if(document.readyState === "loading"){

    document.addEventListener(
        "DOMContentLoaded",
        initialisierePortal
    );

}else{

    initialisierePortal();

}